export default {
  title: 'Betaal met {{method}}',
  hint: 'Tik op de onderstaande knop en keur de betaling goed in het {{method}}-venster.',
  confirming: 'Je betaling wordt bevestigd…',
  cancel: 'Betaling annuleren',
  unavailable: 'Deze betaalmethode is momenteel niet beschikbaar. Kies een andere.',
  approval_timeout:
    'We hebben niets teruggehoord van {{method}}. Als het venster niet is geopend, controleer dan of pop-ups zijn toegestaan en probeer het opnieuw of kies een andere betaalmethode.',
};
